module.exports = __webpack_public_path__ + "img/estatex.673fda6b.png";